import { Children } from 'react';
import { Box } from '@mantine/core';
import classes from './SuperAdminArea.module.css';
import SuperAdminBadge from './SuperAdminBadge';
import SuperAdminGate from './SuperAdminGate';

// Blue dashed frame that groups super-admin-only settings, with a "Super admin"
// badge pinned to the border. Renders nothing for regular users, so at call
// sites it replaces the usual `{isSuperAdmin && (...)}` guard. Pass `show` when
// the caller already holds the role flag (also keeps components renderable
// without a Redux Provider in tests). `inline` turns it into an inline-flex pill
// for grouping buttons inside a toolbar row.
const SuperAdminArea = ({ label, tooltip, inline = false, show, className, children, ...rest }) => {
  // Nothing to frame — don't leave an empty badge-only pill behind when the
  // caller's children are conditionally rendered.
  if (Children.toArray(children).length === 0) {
    return null;
  }

  // `className` is combined rather than spread through `rest`, so a caller
  // adding one can't accidentally drop the frame styling.
  const areaClassName = [classes.area, inline ? classes.inline : null, className].filter(Boolean).join(' ');

  const area = (
    <Box className={areaClassName} {...rest}>
      <span className={classes.badge}>
        <SuperAdminBadge label={label} tooltip={tooltip} show />
      </span>
      {children}
    </Box>
  );

  if (show === undefined) {
    return <SuperAdminGate>{area}</SuperAdminGate>;
  }
  return show ? area : null;
};

export default SuperAdminArea;
